export const catTipoItem = Object.freeze({
    PAQUETE: "PAQUETE",
    EXTRA: "EXTRA",
    PLAZA: "PLAZA",
    SALIDA: "SALIDA"
})